import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./Styles/main.scss";
import Game from "./Components/Game";
import Header from "./Components/Header";
import {
  Routes,
  BrowserRouter as Router,
  Route,
  Navigate,
} from "react-router-dom";
import EngagedCount from "./Components/EngagedCount";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <>
    <Header />
    <Router>
      <Routes>
        <Route path="/" element={<Game />}></Route>
        <Route path="/engagedCount" element={<EngagedCount />}></Route>
        <Route path="*" element={<Navigate to={"/"} />} />
      </Routes>
    </Router>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
